import { render, staticRenderFns } from "./Redactorx.vue?vue&type=template&id=bb95e5da&"
import script from "./Redactorx.vue?vue&type=script&lang=ts&"
export * from "./Redactorx.vue?vue&type=script&lang=ts&"
import style0 from "./Redactorx.vue?vue&type=style&index=0&id=bb95e5da&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports